<template>
  <div class="start-page">
         <!-- 返回按钮 -->
     <div class="back-button" @click="goBack">
       <img src="/img/newLogin/download.png" alt="返回" class="back-icon" />
     </div>
    
         <!-- VIPo状态卡片 -->
     <div class="vipo-card">
       <div v-if="userLoading" class="loading-user">
         <div class="loading-spinner"></div>
         <span>{{ $t('start.loading_user_info') }}</span>
       </div>
       <div v-else class="vipo-left">
         <div class="vipo-icon">V</div>
         <div class="vipo-text">
           <div class="vipo-title">
             {{ userInfo ? `${userInfo.vip || 'o'}` : 'VIPo' }}
           </div>
                                               <div class="vipo-desc">{{ $t('start.daily_orders') }}{{ userInfo && userInfo.daily_order_limit ? `${userInfo.daily_order_limit.daily_limit || 30}` : '30' }}{{ $t('start.orders') }}</div>
                        <div class="vipo-desc">{{ $t('start.commission_rate') }} {{ userInfo ? `${userInfo.daily_order_limit.commission_rate || 0.35}%` : '0.35%' }}</div>
         </div>
       </div>
       <div class="vipo-pattern"></div>
     </div>

    <!-- 统计信息区域 -->
    <div class="stats-section">
             <div class="stats-row">
         <div class="stat-item">
           <div class="stat-value">
             {{ userInfo ? `${userInfo.money || 0}$` : '0$' }}
           </div>
                       <div class="stat-label">{{ $t('start.available_balance') }}</div>
         </div>
         <div class="stat-item">
           <div class="stat-value">0$</div>
                       <div class="stat-label">{{ $t('start.frozen_balance') }}</div>
         </div>
       </div>
       
              <div class="stats-row">
                     <div class="stat-item">
             <div class="stat-value">
               {{ userInfo && userInfo.daily_order_limit ? `${userInfo.daily_order_limit.today_completed || 0}/${userInfo.daily_order_limit.daily_limit || 30}` : '0/30' }}
             </div>
                           <div class="stat-label">{{ $t('start.total_orders') }}</div>
           </div>
          <div class="stat-item">
            <div class="stat-value">
              {{ userInfo ? `${userInfo.today_total_commission || 0}$` : '0$' }}
            </div>
                         <div class="stat-label">{{ $t('start.today_profit') }}</div>
          </div>
        </div>

             <!-- 获取订单按钮 -->
               <div 
          class="action-button" 
          @click="openOrderModal"
          :class="{ 'disabled': isDailyLimitReached || userLoading }"
        >
         <div class="button-icon">⚡</div>
                   <span v-if="userLoading">{{ $t('start.loading_user_info') }}</span>
          <span v-else-if="isDailyLimitReached">{{ $t('start.daily_limit_reached') }}</span>
          <span v-else>{{ $t('start.get_orders_now') }}</span>
       </div>
       <div v-if="isDailyLimitReached" class="daily-limit-notice">
         {{ $t('start.daily_limit_info', { 
           completed: userInfo && userInfo.daily_order_limit ? (userInfo.daily_order_limit.today_completed || 0) : 0, 
           total: userInfo && userInfo.daily_order_limit ? (userInfo.daily_order_limit.daily_limit || 30) : 30 
         }) }}
       </div>
    </div>

    <!-- 任务描述区域 -->
    <div class="task-section">
      <div class="task-title">{{ $t('start.task_description') }}</div>
      <div class="task-content">
        <p>{{ $t('start.task_content_new') }}</p>
      </div>
         </div>
     
           <!-- 成功提示消息 -->
      <div v-if="showSuccess" class="message-toast success-toast">
        <div class="toast-icon">✅</div>
        <span>{{ successMessage }}</span>
      </div>
      
      <!-- 错误提示消息 -->
      <div v-if="showError" class="message-toast error-toast">
        <div class="toast-icon">❌</div>
        <span>{{ errorMessage }}</span>
      </div>
      
        <!-- 订单弹窗 -->
  <div v-if="showOrderModal" class="modal-overlay" @click="closeModal">
    <div class="modal-content" @click.stop>
      <div class="modal-header">
        <h3>{{ $t('start.submit_all_orders') }}</h3>
        <button class="close-btn" @click="closeModal">&times;</button>
      </div>
      
     
         
                   <div class="modal-body">
                         <!-- 未完成订单提示 -->
             <div v-if="showUnfinishedOrderModal" class="unfinished-order-notice">
               {{ $t('start.unfinished_order_notice') }}
             </div>
            
            <!-- 加载状态 -->
            <div v-if="loading" class="loading-order">
              <div class="loading-icon">⏳</div>
              <span>{{ $t('start.loading_orders') }}</span>
            </div>
            
            <!-- 订单信息 -->
                <div v-else-if="currentOrder" class="order-info">
                 <!-- 时间信息 -->
                 <div class="order-time">
                   <span class="time-label">{{ $t('start.time_to_rush') }}</span>
                   <span class="time-value">{{ getCurrentTime() }}</span>
                 </div>
                 
                 <!-- 订单号 -->
                 <div class="order-number">
                   <span class="number-label">{{ $t('start.order_number') }}</span>
                   <span class="number-value">{{ currentOrder.order_id || currentOrder.id }}</span>
                 </div>
                 
                 <!-- 商品详情卡片 -->
                 <div class="goods-card">
                   <!-- 左边图片 -->
                   <div v-if="currentOrder.goods_pic" class="goods-image-section">
                     <img 
                       :src="currentOrder.goods_pic" 
                       :alt="currentOrder.goods_name"
                       class="goods-image"
                       @error="handleImageError"
                     />
                   </div>
                   
                   <!-- 右边介绍 -->
                   <div class="goods-info-section">
                     <div class="goods-name">{{ currentOrder.goods_info }}</div>
                     <div class="goods-brand">Kanta Lekap</div>
                   </div>
                 </div>
                 
                                   <!-- 金额汇总 -->
                  <div class="amount-summary">
                    <div class="amount-row">
                                             <span class="amount-label">{{ $t('start.total_order') }}</span>
                      <span class="amount-value">{{ currentOrder.goods_price }}</span>
                                             <span class="amount-label">{{ $t('start.commission') }}</span>
                      <span class="commission-value">{{ currentOrder.commission }}</span>
                    </div>
                  </div>
               </div>
           
                       <!-- 无订单状态 -->
            <div v-else-if="!showUnfinishedOrderModal" class="no-order">
              <div class="no-order-icon">⚠️</div>
                             <span>{{ $t('start.no_available_orders') }}</span>
            </div>
         </div>
         
                   <div class="modal-footer">
                         <button class="cancel-btn" @click="closeModal">{{ $t('start.cancel') }}</button>
                         <button v-if="currentOrder" 
                     class="place-order-btn" 
                     @click="placeOrder"
                     :disabled="orderLoading">
                               <span v-if="orderLoading">{{ $t('start.payment_processing') }}</span>
                <span v-else>{{ $t('start.confirm_payment') }}</span>
             </button>
                                                    <button v-else class="refresh-btn" @click="goToOrderHistory">{{ $t('start.go_to_view') }}</button>
          </div>
       </div>
     </div>
   </div>
 </template>

<script>
import {http} from '@/http/index'

export default {
  name: 'StartPage',
  data() {
    return {
      showOrderModal: false,
      showUnfinishedOrderModal: false,
      currentOrder: null,
      loading: false,
      orderLoading: false,
      successMessage: '',
      errorMessage: '',
      showSuccess: false,
      showError: false,
      userInfo: null,
      userLoading: false
    }
  },
  created() {
    this.getUserInfo()
  },
  computed: {
    // 检查是否达到每日订单限制
    isDailyLimitReached() {
      if (!this.userInfo || !this.userInfo.daily_order_limit) {
        return false
      }
      const todayCompleted = this.userInfo.daily_order_limit.today_completed || 0
      const dailyLimit = this.userInfo.daily_order_limit.daily_limit || 30
      return todayCompleted >= dailyLimit
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    
         // 获取用户信息
     async getUserInfo() {
       try {
         this.userLoading = true
         const result = await http({
           method: 'get',
           url: 'user_info'
         })
         
         if (result && result.code === 200) {
           this.userInfo = result.data
           console.log('获取用户信息成功:', this.userInfo)
         } else {
           console.error('获取用户信息失败:', result.msg)
         }
       } catch (error) {
         console.error('获取用户信息出错:', error)
       } finally {
         this.userLoading = false
       }
     },
    
             // 打开弹窗并获取订单
    openOrderModal() {
      // 检查是否还在加载用户信息
      if (this.userLoading) {
        this.$toast(this.$t("start.loading_user_info"))
        return
      }
      
      // 检查每日订单限制
      if (this.isDailyLimitReached) {
        this.$toast(this.$t('start.daily_limit_reached'))
        return
      }
      
      this.showOrderModal = true
      this.getUserOrders()
    },
     
           // 关闭弹窗
      closeModal() {
        this.showOrderModal = false
        // 关闭弹窗后刷新用户信息，确保数据同步
        this.getUserInfo()
      },
     
           // 跳转到订单历史页面
      goToOrderHistory() {
        this.showUnfinishedOrderModal = false
        this.$router.push('/GameRecord')
      },
    
             // 获取用户订单信息
    async getUserOrders() {
      try {
        this.loading = true
        const result = await http({
          method: 'get',
          url: 'getUserOrders'
        })
        
        if (result && result.code === 200) {
          // 检查是否有订单
          if (result.data.orders && result.data.orders.length > 0) {
            this.currentOrder = result.data.orders[0]
            console.log('获取订单成功:', this.currentOrder)
          } else {
            // 没有订单，提示余额不足，关闭弹窗
            console.log('没有可用订单，余额不足')
            this.showErrorMessage(this.$t('start.insufficient_balance'))
            this.closeModal()
            this.currentOrder = null
            return
          }
        } else if (result && result.code === 402) {
          // 有未完成的订单
          console.log('有未完成的订单:', result.msg)
          this.showUnfinishedOrderModal = true
        } else if (result && result.code === 401) {
          // 401 错误，显示错误信息，不显示订单弹窗
          console.error('获取订单失败 - 401:', result.msg)
          this.showErrorMessage(result.msg || this.$t("start.get_orders_failed"))
          this.closeModal() // 关闭弹窗
          this.currentOrder = null
        } else {
          console.error('获取订单失败:', result.msg)
          this.currentOrder = null
        }
      } catch (error) {
        console.error('获取订单出错:', error)
        this.currentOrder = null
      } finally {
        this.loading = false
      }
    },
    
         // 执行下单（确认付款）
     async placeOrder() {
       if (!this.currentOrder) {
         alert(this.$t('start.no_available_order'))
         return
       }
       
       try {
         this.orderLoading = true
                   const result = await http({
            method: 'post',
            url: 'placeOrder',
            data: {
              order_id: this.currentOrder.order_id || this.currentOrder.id, // 使用订单ID而不是商品ID
              quantity: 1
            }
          })
         
                                       if (result && result.code === 200) {
             // 显示成功提示
             this.showSuccessMessage(this.$t('start.payment_success'))
             console.log('付款结果:', result.data)
             
             // 立即刷新用户信息，更新今日订单数量
             this.getUserInfo()
             
             // 延迟关闭弹窗，不自动获取新订单
             setTimeout(() => {
               this.closeModal()
             }, 1500)
           } else {
            this.showErrorMessage(this.$t('start.payment_failed') + result.msg)
          }
               } catch (error) {
          console.error('付款出错:', error)
          this.showErrorMessage(this.$t('start.payment_failed_retry'))
        } finally {
         this.orderLoading = false
       }
     },
     
           // 处理图片加载错误
      handleImageError(event) {
        console.log('图片加载失败:', event.target.src)
        // 可以设置一个默认图片
        event.target.style.display = 'none'
        if (event.target.nextElementSibling) {
          event.target.nextElementSibling.style.display = 'block'
        }
      },
      
             // 获取当前时间
       getCurrentTime() {
         const now = new Date()
         const year = now.getFullYear()
         const month = String(now.getMonth() + 1).padStart(2, '0')
         const day = String(now.getDate()).padStart(2, '0')
         const hours = String(now.getHours()).padStart(2, '0')
         const minutes = String(now.getMinutes()).padStart(2, '0')
         const seconds = String(now.getSeconds()).padStart(2, '0')
         return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
       },
       
       // 显示成功提示
       showSuccessMessage(message) {
         this.successMessage = message
         this.showSuccess = true
         setTimeout(() => {
           this.showSuccess = false
         }, 3000)
       },
       
       // 显示错误提示
       showErrorMessage(message) {
         this.errorMessage = message
         this.showError = true
         setTimeout(() => {
           this.showError = false
         }, 3000)
       }
  }
}
</script>

<style lang="less" scoped>
.start-page {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 20px;
  
  // 移动端适配 - 只调整尺寸，保持布局
  @media (max-width: 768px) {
    padding: 16px;
  }
  
  @media (max-width: 480px) {
    padding: 12px;
  }
}

// 返回按钮样式
.back-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
  border: 2px solid #333;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  margin-bottom: 24px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
    transition: left 0.5s ease;
  }
  
  &:hover {
    transform: translateY(-2px);
    background: #111;
    border-color: #555;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.5);
    
    &::before {
      left: 100%;
    }
  }
  
  &:active {
    transform: translateY(0);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  }
}

.back-icon {
  width: 32px;
  height: 32px;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.back-button:hover .back-icon {
  transform: translateX(-3px);
}

// 用户信息加载状态
.loading-user {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #cccccc;
  font-size: 14px;
}

.loading-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid #cccccc;
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.vipo-card {
  background: linear-gradient(135deg, #2c2c2c 0%, #1a1a1a 100%);
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  overflow: hidden;
  
  // 移动端适配 - 只调整尺寸，保持布局
  @media (max-width: 768px) {
    padding: 20px;
    margin-bottom: 16px;
    border-radius: 14px;
  }
  
  @media (max-width: 480px) {
    padding: 16px;
    margin-bottom: 12px;
    border-radius: 12px;
  }
}

.vipo-left {
  display: flex;
  align-items: center;
  z-index: 2;
}

.vipo-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(45deg, #ff6b35, #f7931e);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 20px;
  margin-right: 16px;
  
  // 移动端适配 - 只调整尺寸，保持布局
  @media (max-width: 768px) {
    width: 36px;
    height: 36px;
    font-size: 18px;
    margin-right: 14px;
  }
  
  @media (max-width: 480px) {
    width: 32px;
    height: 32px;
    font-size: 16px;
    margin-right: 12px;
  }
}

.vipo-text {
  color: white;
}

.vipo-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 8px;
  
  // 移动端适配 - 只调整尺寸，保持布局
  @media (max-width: 768px) {
    font-size: 22px;
    margin-bottom: 7px;
  }
  
  @media (max-width: 480px) {
    font-size: 20px;
    margin-bottom: 6px;
  }
}

.vipo-desc {
  font-size: 14px;
  color: #cccccc;
  line-height: 1.4;
  
  // 移动端适配 - 只调整尺寸，保持布局
  @media (max-width: 768px) {
    font-size: 13px;
  }
  
  @media (max-width: 480px) {
    font-size: 12px;
  }
}

.vipo-pattern {
  width: 120px;
  height: 120px;
  background: linear-gradient(45deg, #333, #444);
  border-radius: 50%;
  opacity: 0.3;
  position: absolute;
  right: -20px;
  top: -20px;
  
  // 移动端适配 - 只调整尺寸，保持布局
  @media (max-width: 768px) {
    width: 100px;
    height: 100px;
    right: -15px;
    top: -15px;
  }
  
  @media (max-width: 480px) {
    width: 80px;
    height: 80px;
    right: -10px;
    top: -10px;
  }
}

.stats-section {
  background: white;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 20px;
  
  // 移动端适配 - 只调整尺寸，保持布局
  @media (max-width: 768px) {
    padding: 20px;
    margin-bottom: 16px;
    border-radius: 14px;
  }
  
  @media (max-width: 480px) {
    padding: 16px;
    margin-bottom: 12px;
    border-radius: 12px;
  }
}

.stats-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  
  // 移动端适配 - 只调整尺寸，保持布局
  @media (max-width: 768px) {
    margin-bottom: 20px;
  }
  
  @media (max-width: 480px) {
    margin-bottom: 16px;
  }
}

.stat-item {
  text-align: center;
  flex: 1;
}

.stat-value {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
  
  // 移动端适配 - 只调整尺寸，保持布局
  @media (max-width: 768px) {
    font-size: 24px;
    margin-bottom: 7px;
  }
  
  @media (max-width: 480px) {
    font-size: 22px;
    margin-bottom: 6px;
  }
}

.stat-label {
  font-size: 14px;
  color: #666;
  
  // 移动端适配 - 只调整尺寸，保持布局
  @media (max-width: 768px) {
    font-size: 13px;
  }
  
  @media (max-width: 480px) {
    font-size: 12px;
  }
}

.action-button {
  background: #000;
  color: white;
  border: none;
  border-radius: 12px;
  padding: 16px 32px;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  cursor: pointer;
  transition: all 0.3s ease;
  
  // 移动端适配 - 只调整尺寸，保持布局
  @media (max-width: 768px) {
    padding: 14px 24px;
    font-size: 15px;
    border-radius: 10px;
  }
  
  @media (max-width: 480px) {
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 8px;
  }
}

.action-button:hover {
  background: #333;
  transform: translateY(-2px);
}

.action-button.disabled {
  background: #ccc;
  color: #666;
  cursor: not-allowed;
  transform: none;
}

.action-button.disabled:hover {
  background: #ccc;
  transform: none;
}

.daily-limit-notice {
  text-align: center;
  color: #ef4444;
  font-size: 14px;
  margin-top: 8px;
  padding: 8px 16px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  
  // 移动端适配
  @media (max-width: 768px) {
    font-size: 13px;
    padding: 6px 12px;
    margin-top: 6px;
  }
  
  @media (max-width: 480px) {
    font-size: 12px;
    padding: 4px 8px;
    margin-top: 4px;
  }
}

.button-icon {
  margin-right: 8px;
  font-size: 18px;
  
  // 移动端适配 - 只调整尺寸，保持布局
  @media (max-width: 768px) {
    font-size: 16px;
    margin-right: 6px;
  }
  
  @media (max-width: 480px) {
    font-size: 14px;
    margin-right: 4px;
  }
}

.task-section {
  background: white;
  border-radius: 16px;
  padding: 24px;
  
  // 移动端适配 - 只调整尺寸，保持布局
  @media (max-width: 768px) {
    padding: 20px;
    border-radius: 14px;
  }
  
  @media (max-width: 480px) {
    padding: 16px;
    border-radius: 12px;
  }
}

.task-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 16px;
  
  // 移动端适配 - 只调整尺寸，保持布局
  @media (max-width: 768px) {
    font-size: 18px;
    margin-bottom: 14px;
  }
  
  @media (max-width: 480px) {
    font-size: 16px;
    margin-bottom: 12px;
  }
}

.task-content {
  color: #666;
  line-height: 1.6;
}

.task-content p {
  margin-bottom: 12px;
  font-size: 14px;
  
  // 移动端适配 - 只调整尺寸，保持布局
  @media (max-width: 768px) {
    font-size: 13px;
    margin-bottom: 10px;
  }
  
  @media (max-width: 480px) {
    font-size: 12px;
    margin-bottom: 8px;
  }
}

.task-content p:last-child {
  margin-bottom: 0;
}

// 横屏适配 - 只调整尺寸，保持布局
@media (orientation: landscape) and (max-height: 600px) {
  .start-page {
    padding: 12px;
  }
  
  .vipo-card,
  .stats-section,
  .task-section {
    margin-bottom: 12px;
    padding: 16px;
  }
  
  .stats-row {
    margin-bottom: 16px;
  }
}

// 大屏幕适配 - 只调整尺寸，保持布局
@media (min-width: 1200px) {
  .start-page {
    max-width: 800px;
    margin: 0 auto;
    padding: 32px;
  }
  
  .vipo-card,
  .stats-section,
  .task-section {
    padding: 32px;
    margin-bottom: 24px;
  }
  
  .vipo-title {
    font-size: 28px;
  }
  
  .stat-value {
    font-size: 32px;
  }
  
     .task-title {
     font-size: 24px;
   }
 }

// 提示消息样式
.message-toast {
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 16px 20px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 16px;
  font-weight: 500;
  z-index: 2000;
  animation: slideInRight 0.3s ease-out;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  max-width: 300px;
  
  .toast-icon {
    font-size: 20px;
    flex-shrink: 0;
  }
  
  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.success-toast {
  background: #10b981;
  color: white;
  border: 1px solid #059669;
}

.error-toast {
  background: #ef4444;
  color: white;
  border: 1px solid #dc2626;
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

// 未完成订单内嵌提示样式
.unfinished-order-notice {
  text-align: center;
  color: #d97706;
  font-size: 16px;
  padding: 20px;
  margin-bottom: 20px;
  background: #fef3c7;
  border-radius: 8px;
}

// 弹窗样式 - 白色主题
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: #fff;
  border: none;
  border-radius: 16px;
  width: 100%;
  max-width: 500px;
  height: auto;
  overflow: visible;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 28px;
  border-bottom: 1px solid #e5e7eb;
  background: #fff;
  position: relative;
}

.modal-header h3 {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  color: #000;
}

.close-btn {
  background: #f3f4f6;
  border: 1px solid #d1d5db;
  font-size: 20px;
  cursor: pointer;
  color: #6b7280;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
  
  &:hover {
    background: #e5e7eb;
    color: #374151;
    border-color: #9ca3af;
    transform: scale(1.1);
  }
}

.modal-body {
  padding: 20px;
  height: auto;
  overflow: visible;
  background: #fff;
}

.modal-footer {
  padding: 24px 28px;
  border-top: 1px solid #e5e7eb;
  background: #fff;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  position: relative;
}

// 订单信息样式 - 白色主题
.order-info {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

// 时间信息
.order-time {
  display: flex;
  align-items: center;
  gap: 8px;
  
  .time-label {
    font-size: 13px;
    color: #6b7280;
    font-weight: 500;
    white-space: nowrap;
  }
  
  .time-value {
    font-size: 14px;
    color: #000;
    font-weight: 600;
    font-family: 'Courier New', monospace;
  }
}

// 订单号
.order-number {
  display: flex;
  align-items: center;
  gap: 8px;
  
  .number-label {
    font-size: 13px;
    color: #6b7280;
    font-weight: 500;
    white-space: nowrap;
  }
  
  .number-value {
    font-size: 14px;
    color: #000;
    font-weight: 600;
    font-family: 'Courier New', monospace;
  }
}

// 商品详情卡片
.goods-card {
  display: flex;
  gap: 12px;
  padding: 12px;
  background: #f9fafb;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
}

.goods-image-section {
  flex: 0 0 80px;
  
  .goods-image {
    width: 100%;
    height: 80px;
    object-fit: cover;
    border-radius: 8px;
    border: 1px solid #d1d5db;
  }
}

.goods-info-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  
  .goods-name {
    font-size: 14px;
    color: #000;
    font-weight: 600;
    line-height: 1.3;
  }
  
  .goods-brand {
    font-size: 12px;
    color: #6b7280;
    font-weight: 500;
  }
}

// 金额汇总
.amount-summary {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  background: #f9fafb;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
}

.amount-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  
  .amount-label {
    font-size: 18px;
    color: #000;
    font-weight: 600;
    white-space: nowrap;
  }
  
  .amount-value {
    font-size: 24px;
    color: #000;
    font-weight: 700;
    margin-right: 24px;
  }
  
  .commission-value {
    font-size: 24px;
    color: #f97316;
    font-weight: 700;
  }
}



// 按钮样式 - 白色主题
.place-order-btn {
  background: #8b5cf6;
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 14px 28px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  
  &:hover:not(:disabled) {
    background: #7c3aed;
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(139, 92, 246, 0.3);
  }
  
  &:disabled {
    background: #d1d5db;
    color: #9ca3af;
    cursor: not-allowed;
    box-shadow: none;
  }
}

.refresh-btn {
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 12px;
  padding: 14px 28px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  
  &:hover {
    background: #2563eb;
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(59, 130, 246, 0.3);
  }
}

.cancel-btn {
  background: #fff;
  color: #6b7280;
  border: 1px solid #d1d5db;
  border-radius: 12px;
  padding: 14px 28px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  
  &:hover {
    background: #f9fafb;
    color: #374151;
    border-color: #9ca3af;
    transform: translateY(-2px);
  }
}

// 加载状态样式 - 白色主题
.loading-order {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #3b82f6;
  background: #eff6ff;
  border: 1px solid #dbeafe;
  border-radius: 16px;
  margin: 20px 0;
}

.loading-icon {
  font-size: 28px;
  margin-right: 16px;
  animation: spin 1s linear infinite;
  color: #3b82f6;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

// 无订单状态样式 - 白色主题
.no-order {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #ef4444;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 16px;
  margin: 20px 0;
}

.no-order-icon {
  font-size: 36px;
  margin-bottom: 16px;
  color: #ef4444;
}

// 移动端适配 - 提示消息
@media (max-width: 768px) {
  .message-toast {
    top: 16px;
    right: 16px;
    left: 16px;
    max-width: none;
    padding: 14px 18px;
    font-size: 15px;
    
    .toast-icon {
      font-size: 18px;
    }
  }
}

@media (max-width: 480px) {
  .message-toast {
    top: 12px;
    right: 12px;
    left: 12px;
    padding: 12px 16px;
    font-size: 14px;
    
    .toast-icon {
      font-size: 16px;
    }
  }
}

// 移动端适配 - 白色主题
@media (max-width: 768px) {
  .modal-content {
    max-width: 90vw;
    margin: 20px;
    border-radius: 16px;
  }
  
  .modal-header,
  .modal-body,
  .modal-footer {
    padding: 20px 24px;
  }
  
  .modal-header h3 {
    font-size: 20px;
  }
  
  .goods-card {
    flex-direction: column;
    gap: 16px;
  }
  
  .goods-image-section {
    flex: none;
    width: 100%;
    text-align: center;
    
         .goods-image {
       width: 80px;
       height: 80px;
     }
  }
  
  .place-order-btn,
  .refresh-btn,
  .cancel-btn {
    padding: 12px 24px;
    font-size: 15px;
  }
}

@media (max-width: 480px) {
  .modal-content {
    max-width: 95vw;
    margin: 10px;
    border-radius: 14px;
  }
  
  .modal-header,
  .modal-body,
  .modal-footer {
    padding: 16px 20px;
  }
  
  .modal-header h3 {
    font-size: 18px;
  }
  
  .goods-card {
    padding: 16px;
    gap: 12px;
  }
  
  .goods-image-section .goods-image {
    width: 80px;
    height: 80px;
  }
  
  .place-order-btn,
  .refresh-btn,
  .cancel-btn {
    padding: 10px 20px;
    font-size: 14px;
  }
}
</style>
